import { createFileRoute } from "@tanstack/react-router";
import { MarketingHeader } from "@/components/marketing/marketing-header";
import { MarketingFooter } from "@/components/marketing/marketing-footer";
import { DemoSection } from "@/components/marketing/demo-section";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/demo")({
  head: () => seoMeta({
    title: "Demo interattiva - LexAIPro",
    description:
      "Prova LexAIPro senza registrazione: ricerca legale, analisi documenti e redazione assistita in azione.",
    path: "/demo",
  }),
  component: DemoPage,
});

function DemoPage() {
  return (
    <div className="min-h-screen bg-background">
      <MarketingHeader />
      <main className="pt-24">
        <div className="mx-auto max-w-5xl px-6 pt-12 pb-6 text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Provala in azione</p>
          <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
            Vedi LexAIPro all'opera.
          </h1>
          <p className="mt-4 mx-auto max-w-2xl text-lg text-muted-foreground">
            Demo interattiva - nessuna registrazione richiesta. Prova ricerca, analisi e redazione con esempi reali.
          </p>
        </div>
        <DemoSection />
      </main>
      <MarketingFooter />
    </div>
  );
}
